import { CarriersController } from "../controllers/carriers-controller";
import { Carrier } from "../models/carrier"
import { CarrierFilter } from "../models/carrier-filter"
import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

//import 'ag-grid-enterprise/main';
import { observable, computedFrom, autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import * as condition from './widgets/list-filter/condition';
import { Division } from "../models/division";
import { Contact } from "../models/contact";
import { DialogService } from "aurelia-dialog";
import { UpdateDivisionContactDialog } from "./dialogs/update-division-contact-dialog";
import { AppMessageService } from "../services/app-message-service";

@singleton()
@autoinject()
export class Landing {

    constructor(
        private busyService: BusyService,
        private dialogService: DialogService,
        private appMessageService: AppMessageService,
        private api: WebApiService) {
    }

    public emailLogComponent: any;

    async activate(params) {
    }



}